import { Component, Input, ElementRef, OnInit, Output, EventEmitter, ViewEncapsulation, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { FileUpload } from 'primeng/fileupload'; import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { Capacitor } from '@capacitor/core';
import { MobileUploadService } from 'src/app/services/mobile-upload.service';
@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {

 
  @Input() isMobile: boolean = false;
  @Input() isSlicks: boolean = false;
  @Input() previewVariant: 'default' | 'wallpaper' | 'logo' = 'default';
  @Input() public previewUrl: string | null = null;
  @Input() forceHidePreview: boolean = false;

  @Input() errorSize: boolean = false;
  @Input() errorType: boolean = false;
  @Input() required: boolean = false;
  @Input() requiredError: boolean = false;

  @Input() canEdit: boolean = true;

  @Input() fileName: string | null = null;

  @Output() fileSelected = new EventEmitter<File>();
  @Output() removeFile = new EventEmitter<void>();

  @Output() fileValid = new EventEmitter<boolean>();
  @Output() fileInvalid = new EventEmitter<string>();



  constructor(private mobileUploadService: MobileUploadService) {
    console.log('[Capacitor] referenced in UploadFileComponent');
    }

  isNativeAndroid(): boolean {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
  }

  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['previewUrl'] && this.previewUrl && !this.mediaType) {
      if (this.accept === 'image') {
        this.mediaType = 'image';
      } else if (this.accept === 'video') {
        this.mediaType = 'video';
      } else {
        // Tenta adivinhar se não estiver explícito
        this.mediaType = this.previewUrl.match(/\.(mp4|mov|webm|avi|mkv|flv)$/i) ? 'video' : 'image';
      }
    }
  }
  @Input() accept: 'image' | 'video' | 'image,video' = 'image';
  async abrirUpload() {
    if (this.isNativeAndroid()) {
      let file: File | null = null;
  
      if (this.accept === 'image,video') {
        const mediaType = await this.mobileUploadService.promptMediaSelection();
  
        if (mediaType === 'image') {
          file = await this.mobileUploadService.selectImage();
        } else if (mediaType === 'video') {
          file = await this.mobileUploadService.selectVideo();
        }
      } else if (this.accept === 'image') {
        file = await this.mobileUploadService.selectImage();
      } else if (this.accept === 'video') {
        file = await this.mobileUploadService.selectVideo();
      }
  
      if (file) {
        this.processFile(file);
      }
    }
  }
  private processFile(file: File): void {
    const ext = file.name.split('.').pop()?.toLowerCase() || '';
    const isImage = ['jpg', 'jpeg', 'png', 'webp', 'avif', 'jfif'].includes(ext);
    const isVideo = ['mp4', 'mov', 'webm', 'avi', 'wmv', 'mkv', 'flv', 'mpeg', 'mpg', '3gp', 'm4v'].includes(ext);

    const valid = isImage || isVideo;

    if (!valid) {
      this.invalidAttemptType = this.getGuessedType(file.name);
      this.fileInvalid.emit('type');
      return;
    }

    // ✅ Agora podemos definir com certeza o tipo tentado
    this.invalidAttemptType = isImage ? 'image' : 'video';

    const maxSize = isVideo ? 400 * 1024 * 1024 : 1 * 1024 * 1024;
    if (file.size > maxSize) {
      this.fileInvalid.emit('size');
      return;
    }

    this.mediaType = this.invalidAttemptType;
    this.fileValid.emit(true);
    this.fileSelected.emit(file);
    this.previewUrl = URL.createObjectURL(file);
  }

  async ngOnInit() {
    if (this.isNativeAndroid()) {
      const granted = await this.mobileUploadService.requestAndroidPermissions();
      if (!granted) {
        console.warn('Permissões não foram concedidas. Alguns recursos podem não funcionar.');
      }
    }
  }

  getAcceptMime(): string {
    switch (this.accept) {
      case 'image':
        return '.jpg,.jpeg,.png,.webp,.avif,image/jpeg,image/png,image/webp,image/avif';
      case 'video':
        return 'video/*';
      case 'image,video':
      default:
        return 'image/*,video/*';
    }
  }

  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;



  handleFileChange(event: Event) {
    const file = (event.target as HTMLInputElement)?.files?.[0];
    if (file) {
      this.processFile(file);
    }
  }
  dropped(files: NgxFileDropEntry[]) {
    if (files.length === 0) return;

    const droppedFile = files[0];

    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        const maxSize = 1048576; // 1MB
        const allowedTypes = ['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'];

        if (file.size > maxSize) {
          this.fileInvalid.emit('size');
          return;
        }

        if (!allowedTypes.includes(file.type)) {
          this.fileInvalid.emit('type');
          return;
        }

        this.fileValid.emit(true);
        this.fileSelected.emit(file);
      });
    }
  }

  @ViewChild('fileUploader') fileUploader!: FileUpload;
  handlePrimeNgDrop(event: any) {
    const file: File = event.files?.[0];

    console.log('handlePrimeNgDrop 1');
    console.log(file);
    if (!file) return;

    console.log('handlePrimeNgDrop 2');

    const maxSize = 1048576;
    const allowedTypes = ['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'];

    if (file.size > maxSize) {
      this.fileInvalid.emit('size');
      this.fileUploader.clear();
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      this.fileInvalid.emit('type');
      this.fileUploader.clear();
      return;
    }

    this.fileValid.emit(true);
    this.fileSelected.emit(file);
    this.previewUrl = URL.createObjectURL(file);
  }


  handleRemove() {
    this.previewUrl = null;
    this.mediaType = null;
    this.reset();
    this.removeFile.emit();
  }
  reset(): void {
    // Zera o input nativo
    if (this.fileInputRef?.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }

    // Limpa o PrimeNG FileUpload se estiver presente
    if (this.fileUploader) {
      this.fileUploader.clear();
    }

    // Limpa preview
    this.previewUrl = null;
    this.mediaType = null;

    // Emite evento se necessário
    this.fileValid.emit(false);
  }

  isDragOver = false;
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    const file = event.dataTransfer?.files?.[0];
    if (file) {
      this.processFile(file);
    }
  }
  mediaType: 'image' | 'video' | null = null;
  invalidAttemptType: 'image' | 'video' | null = null;



  private getGuessedType(filename: string): 'image' | 'video' {
    const ext = filename.split('.').pop()?.toLowerCase() || '';
    const imageExts = ['jpg', 'jpeg', 'png', 'webp', 'avif'];
    const videoExts = ['mp4', 'mov', 'webm', 'avi', 'wmv', 'mkv', 'flv', 'mpeg', 'mpg', '3gp', 'm4v'];

    if (imageExts.includes(ext)) return 'image';
    if (videoExts.includes(ext)) return 'video';
    return 'video'; // fallback: assume vídeo para não mostrar erro genérico
  }


}

